import { formatSAR } from "@/utils/format";
import type { BranchDetail } from "@/types";

interface BranchInfoTabProps {
  branch: BranchDetail;
  employeesCount: number;
  managerName: string;
}

export default function BranchInfoTab({
  branch,
  employeesCount,
  managerName,
}: BranchInfoTabProps) {
  const infoItems = [
    { label: "المدينة", value: branch.city, icon: "ri-map-pin-2-line" },
    { label: "العنوان", value: branch.address, icon: "ri-map-pin-line" },
    { label: "هاتف الفرع", value: branch.phone || "غير محدد", icon: "ri-phone-line", dir: "ltr" as const },
    { label: "مدير الفرع", value: managerName, icon: "ri-user-star-line" },
    { label: "أوقات العمل", value: branch.hours, icon: "ri-time-line" },
    {
      label: "عدد الموظفين",
      value: `${employeesCount} موظف`,
      icon: "ri-team-line",
    },
    {
      label: "طلبات اليوم",
      value: String(branch.ordersToday),
      icon: "ri-shopping-bag-3-line",
    },
    {
      label: "مبيعات اليوم",
      value: formatSAR(branch.salesToday),
      icon: "ri-money-dollar-circle-line",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {infoItems.map((item) => (
        <div
          key={item.label}
          className="flex items-start gap-3 rounded-btn border border-background-200 px-4 py-3"
        >
          <span className="w-8 h-8 shrink-0 flex items-center justify-center rounded-full bg-background-100 text-foreground-500">
            <i className={item.icon}></i>
          </span>
          <div className="min-w-0">
            <p className="text-xs text-foreground-500">{item.label}</p>
            <p
              className="mt-0.5 text-sm font-semibold text-foreground-950"
              dir={item.dir}
            >
              {item.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}